// extracted by mini-css-extract-plugin
module.exports = {"trial-landing-page":"trial-landing-page__2wB12","nagoya-design-banner":"nagoya-design-banner__a-gSo"};